import { QueryString } from 'Helpers';
import AVAILABLE_LANGUAGES from 'Constants/Languages';
import { getHotelsList } from 'Actions/hotels';
import * as QueryParameters from 'Constants/QueryParameters';

export const changePromoCode = (id, promoCode) => (dispatch) => {
    dispatch({ id, type: 'CHANGE_PROMO_CODE', payload: promoCode });
};

/**
 * Used when fetching offers from EE, and currency type has to be replaced
 *
 * @param {string} currency
 */
export const setCurrencyType = currency => (dispatch) => {
    dispatch({ type: 'SET_CURRENCY_TYPE', payload: currency });
};

export const changeCurrency = currency => (dispatch, getState) => {
    let validCurrency = currency;
    if (typeof currency === 'string') {
        const { settings } = getState();
        const upperCaseCurrency = currency.toUpperCase();
        if (upperCaseCurrency in settings.data.availableCurrencies) {
            validCurrency = settings.data.availableCurrencies[upperCaseCurrency];
        } else {
            validCurrency = settings.data.defaultCurrency;
        }
    }

    dispatch({ type: 'CHANGE_CURRENCY', payload: validCurrency });

    const currencyEvent = new CustomEvent('changecurrency', { bubbles: true, cancelable: false, detail: { currency: validCurrency } });
    document.dispatchEvent(currencyEvent);
};

export const changeLanguage = lang => async (dispatch, getState) => {
    const validLanguage = AVAILABLE_LANGUAGES.includes(lang.toLowerCase()) ? lang.toLowerCase() : AVAILABLE_LANGUAGES[0];
    const { domain, hotelsFilters } = getState().settings.data;
    const { isMultiProperty, channelId, hotels } = getState().widgetPool[0].config;
    const language = lang;
    const params = !isMultiProperty ? { domain, language } : { channelId, hotels, hotelsFilters };
    await dispatch({ type: 'CHANGE_LANGUAGE', payload: validLanguage });
    if (isMultiProperty) {
        await dispatch(getHotelsList({ ...params, hotels }));
    }

    const languageEvent = new CustomEvent('changelanguage', { bubbles: true, cancelable: false, detail: { language: validLanguage } });
    document.dispatchEvent(languageEvent);

    return { language: validLanguage };
};

export const changeDates = (id, checkIn, checkOut) => (dispatch, getState) => {
    const { destinations, settings, search } = getState();
    const destinationSelected = destinations.selected;
    const { los } = settings.data;
    const { checkIn: previousCheckIn, checkOut: previousCheckOut } = search.data;
    dispatch({
        type    : 'CHANGE_DATES',
        payload : {
            checkIn,
            checkOut,
            destinationSelected,
            los,
            previousCheckIn,
            previousCheckOut,
        },
        id,
    });
};

export const changeUserAgent = userAgent => dispatch => dispatch({ type: 'CHANGE_USER_AGENT', payload: userAgent });

export const changeRoomsQuantity = (id, numberOfRooms) => (dispatch, getState) => {
    const { settings } = getState();
    const { defaultOccupancy } = settings.data;
    dispatch({ type: 'CHANGE_ROOMS_QUANTITY', payload: { numberOfRooms, defaultOccupancy }, id });
};

export const removeRoom = (id, index) => (dispatch) => {
    dispatch({ type: 'REMOVE_ROOM', payload: { index }, id });
};

export const changeAdults = (id, adultsRoomIndex, numberOfAdults) => (dispatch) => {
    dispatch({ type: 'CHANGE_ADULTS', payload: { adultsRoomIndex, numberOfAdults }, id });
};

export const changeChildren = (id, childrenRoomIndex, numberOfChildren) => (dispatch, getState) => {
    const state = getState();
    const { maxChildAge, minChildAge } = state.settings.data;
    let childAge = (maxChildAge !== -1) ? 0 : -1;

    if (minChildAge !== -1) {
        childAge = minChildAge;
    }

    dispatch({ type: 'CHANGE_CHILDREN', payload: { childrenRoomIndex, numberOfChildren, childAge }, id });
};

export const changeChildrenAge = (id, childrenAgeRoomIndex, childIndex, childrenAge) => (dispatch) => {
    dispatch({ type: 'CHANGE_CHILDREN_AGE', payload: { childrenAgeRoomIndex, childIndex, childrenAge }, id });
};

export const searchResults = id => dispatch => dispatch({ type: 'SEARCH_RESULTS', id });

export const getURLParams = (id = null,
    code = null,
    isOffer = null,
    readable = false,
    availableDaterange = null,
    checkIn = null,
    checkOut = null,
) =>
    (dispatch, getState) => {
        const state = getState();
        const { shouldTakeRedirectDomainFromApi, ntpDomain, domain:defaultDomain } = state.settings.data;
        let domain = shouldTakeRedirectDomainFromApi ? ntpDomain : defaultDomain;
        const currentWidgetConfig = state.widgetPool.find(widget => widget.config.id === id);
        const { config } = currentWidgetConfig || { config: {} };
        const { isMultiProperty } = state.widgetPool[0].config;
        const { type: autocompleteType, code: autocompletePropertyCode } = state.hotels?.autocompleteData ?? { type: '', code: '' };

        let query;

        if (config.widgetType && config.widgetType === 'echo') {
            domain = `${domain}/property/${config.propertyCode}`;
        }
        if (autocompleteType === 'hotel') {
            domain = `${domain}/property/${autocompletePropertyCode}`;
        }

        if (availableDaterange) {
            domain = `${domain}/package/${code}`;
        }

        if (!isMultiProperty) {
            query = QueryString.transformStateToParams(id, state, code, isOffer, readable, availableDaterange);
        } else {
            query = QueryString.transformStateToMultiPropertyParams(state, readable);
        }

        if (checkIn) {
            query[QueryParameters.QUERY_PARAMETERS.CHECKIN] = checkIn;
        }

        if (checkOut) {
            query[QueryParameters.QUERY_PARAMETERS.CHECKOUT] = checkOut;
        }

        return { domain, query };
    };

export const setRoomsWarning = payload => (dispatch) => {
    dispatch({ type: 'SET_ROOMS_WARNING', payload });
};

export const setSearchKey = payload => (dispatch) => {
    dispatch({ type: 'SET_SEARCH_KEY', payload });
};

export const updateCoupon = payload => (dispatch) => {
    dispatch({ type: 'UPDATE_COUPON', payload });
};

